module.exports = __webpack_public_path__ + "static/media/L3.bcbea4d5.jpg";